// import axios from 'axios';
import api from '../utils/api';

export const liquorService = {
    getDashboardStats: async (fy, subCountyId) => {
        const response = await api.get('/liquor/dashboard', {
            params: { fy, subCountyId }
        });
        return response.data;
    },
    fetchLiquorItemReport: async ({ financial_year, sub_county_id }) => {
        const response = await api.get('/liquor/item-report', {
            params: { financial_year, sub_county_id }
        });
        return response.data;
    }
};